import CoPayIcon from './category-images/co_pay.svg';
import MentalHealthSupport from './category-images/mental_health_support.svg';
import MealAndFoodSupport from './category-images/meal_and_food_support.svg';
import Support from './category-images/support.svg';
import SupportGroup from './category-images/support_groups.svg';
import FinancialSupport from './category-images/financial_support.svg';
import Lodging from './category-images/lodging.svg';
import MedicalExpenses from './category-images/medical_expenses.svg';
import Transportation from './category-images/transportation.svg';
import TravelExpenses from './category-images/travel_expenses.svg';
import CaregiverSupport from './category-images/caregiver_support.svg';
import Legal from './category-images/legal.svg';
import PetCareSupport from './category-images/pet_care_support.svg';
import ChildCareSupport from './category-images/child_care_support.svg';

const categoriesMap = {
  'Co-Pay': {
    name: 'co_pay',
    label: 'Co-Pay',
    icon: CoPayIcon,
    description: 'Assistance provided to help cover the out-of-pocket costs that patients are required to pay for their medical treatments, medications, and doctor visits, which are not fully covered by insurance',
    width: 21,
    height: 22,
  },
  'Mental Health Support': {
    name: 'mental_health_support',
    label: 'Mental Health Support',
    icon: MentalHealthSupport,
    description: 'Financial aid or services that cover counseling, therapy, and other mental health services to help patients and their families cope with the emotional and psychological challenges of a cancer diagnosis and treatment',
    width: 19,
    height: 18,
  },
  'Pet Care Support': {
    name: 'pet_care_support',
    label: 'Pet Care Support',
    icon: PetCareSupport,
    description: 'Financial assistance or services that help with the care of a patient\'s pets, including costs for pet sitting, veterinary care, and feeding, ensuring that pets are well-cared for during the patient\'s treatment and recovery periods',
    width: 27,
    height: 26,
  },
  'Meal & Food Support': {
    name: 'meal_and_food_support',
    label: 'Meal & Food Support',
    icon: MealAndFoodSupport,
    description: 'Programs that provide meals, groceries, or financial aid to purchase food for cancer patients who may be unable to prepare meals themselves due to treatment side effects or financial constraints',
    width: 19,
    height: 20,
  },
  Support: {
    name: 'support',
    label: 'Support',
    icon: Support,
    description: 'General assistance that might include a variety of services or financial aid to help patients with various needs that arise during their cancer journey',
    width: 18,
    height: 20,
  },
  'Support Group': {
    name: 'support_group',
    label: 'Support Group',
    icon: SupportGroup,
    description: 'Financial support for joining or forming support groups where patients and their families can share experiences, receive emotional support, and gain practical advice from others going through similar situations',
    width: 17,
    height: 20,
  },
  'Financial Support': {
    name: 'financial_support',
    label: 'Financial Support',
    icon: FinancialSupport,
    description: 'Broad financial aid that helps cover various costs associated with cancer treatment, including medical bills, living expenses, and other related costs that can cause financial strain',
    width: 24,
    height: 24,
  },
  Lodging: {
    name: 'lodging',
    label: 'Lodging',
    icon: Lodging,
    description: 'Assistance with temporary housing costs for patients and their families who need to travel far from home for treatment, ensuring they have a comfortable and affordable place to stay during their treatment period',
    width: 20,
    height: 18,
  },
  'Medical Expenses': {
    name: 'medical_expenses',
    label: 'Medical Expenses',
    icon: MedicalExpenses,
    description: 'Financial aid specifically targeted at covering medical costs, including hospital bills, medications, medical equipment, and other treatment-related expenses',
    width: 16,
    height: 18,
  },
  Transportation: {
    name: 'transportation',
    label: 'Transportation',
    icon: Transportation,
    description: 'Programs that provide financial aid or services for transportation to and from treatment facilities, ensuring patients can attend their appointments without the added stress of transportation costs',
    width: 19,
    height: 18,
  },
  'Travel Expenses': {
    name: 'travel_expenses',
    label: 'Travel Expenses',
    icon: TravelExpenses,
    description: 'Financial support for travel-related costs such as airfare, gas, or public transportation for patients who need to travel long distances to receive treatment',
    width: 19,
    height: 18,
  },
  'Caregiver Support': {
    name: 'caregiver_support',
    label: 'Caregiver Support',
    icon: CaregiverSupport,
    description: 'Assistance for those providing care to cancer patients, including financial aid, respite care, training, and resources to support caregivers in managing their responsibilities',
    width: 21,
    height: 21,
  },
  'Legal Assistance': {
    name: 'legal_assistance',
    label: 'Legal Assistance',
    icon: Legal,
    description: 'Financial aid or services that help patients with legal issues related to their diagnosis, such as navigating insurance claims, employment rights, advance directives, and other legal matters',
    width: 18,
    height: 18,
  },
  'Medical Support': {
    name: 'medical_support',
    label: 'Medical Support',
    icon: Support,
    description: 'General financial aid for various medical-related needs that may not be covered under specific categories, including specialist consultations, second opinions, and medical supplies',
    width: 18,
    height: 20,
  },
  'Child Care Support': {
    name: 'child_care_support',
    label: 'Child Care Support',
    icon: ChildCareSupport,
    description: 'Financial assistance or services that help cover the costs of child care for patients undergoing treatment, ensuring their children are cared for while they focus on their recovery',
    width: 27,
    height: 26,
  },

  'Wellbeing Support': {
    name: 'wellbeing_support',
    label: 'Wellbeing Support',
    icon: MentalHealthSupport,
    description: 'Financial aid or services that cover counseling, therapy, and other mental health services to help patients and their families cope with the emotional and psychological challenges of a cancer diagnosis and treatment',
    width: 19,
    height: 18,
  },
  'Caregiver Support Group': {
    name: 'caregiver_support_group',
    label: 'Caregiver Support Group',
    icon: CaregiverSupport,
    description: 'Assistance for those providing care to cancer patients, including financial aid, respite care, training, and resources to support caregivers in managing their responsibilities',
    width: 21,
    height: 21,
  },
  'Patient Support Group': {
    name: 'patient_support_group',
    label: 'Patient Support Group',
    icon: SupportGroup,
    description: 'Financial support for joining or forming support groups where patients and their families can share experiences, receive emotional support, and gain practical advice from others going through similar situations',
    width: 17,
    height: 20,
  },
  'Caregivers Wellbeing Support': {
    name: 'caregivers_wellbeing_support',
    label: 'Caregivers Wellbeing Support',
    icon: CaregiverSupport,
    description: 'Assistance for those providing care to cancer patients, including financial aid, respite care, training, and resources to support caregivers in managing their responsibilities',
    width: 21,
    height: 21,
  },
  'Family Support Group': {
    name: 'family_support_group',
    label: 'Family Support Group',
    icon: SupportGroup,
    description: 'Financial support for joining or forming support groups where patients and their families can share experiences, receive emotional support, and gain practical advice from others going through similar situations',
    width: 17,
    height: 20,
  },
  'Families and Friends Support Group': {
    name: 'families_and_friends_support_froup',
    label: 'Families and Friends Support Group',
    icon: SupportGroup,
    description: 'Financial support for joining or forming support groups where patients and their families can share experiences, receive emotional support, and gain practical advice from others going through similar situations',
    width: 17,
    height: 20,
  },
  'Patient Wellbeing Support': {
    name: 'patient_wellbeing_support',
    label: 'Patient Wellbeing Support',
    icon: MentalHealthSupport,
    description: 'Financial aid or services that cover counseling, therapy, and other mental health services to help patients and their families cope with the emotional and psychological challenges of a cancer diagnosis and treatment',
    width: 19,
    height: 18,
  },
};

const getFallBackIcon = (categoryName) => ({
  name: categoryName.toLowerCase().replace(/\s+/g, '_'),
  label: categoryName,
  icon: SupportGroup,
  description: '',
  width: 17,
  height: 20,
});

const countProgramsByCategory = (programs) => {
  const programsCount = {};
  for (const program of programs) {
    const categoryName = program.category?.toLowerCase();
    if (!programsCount[categoryName]) {
      programsCount[categoryName] = 0;
    }
    programsCount[categoryName] += 1;
  }
  return programsCount;
};

const arrangeCategories = (categories, programs, existingCategories) => {
  const programsCount = countProgramsByCategory(programs);
  const selectedCategoriesInLowerCase = (existingCategories ?? []).map((i) => i.toLowerCase());

  const result = [];
  for (const categoryName of categories) {
    const category = {
      ...(categoriesMap[categoryName] ?? getFallBackIcon(categoryName)),
    };
    const labelInLowerCase = category.label.toLowerCase();
    category.selected = selectedCategoriesInLowerCase.length
      ? selectedCategoriesInLowerCase.includes(labelInLowerCase)
      : true;
    category.program_count = programsCount[labelInLowerCase] ?? 0;
    result.push(category);
  }
  return result;
};

export {
  categoriesMap,
  arrangeCategories,
};
